import React from "react";
import PropTypes from "prop-types";

import { Badge } from "./badge";
import { useDeviceType } from "../../customHooks/useDeviceType";

import "./individual-page.m.css";

export const handleBagdes = (badgeData, onScroll, onBadgeClick) => {
  const RenderBadge = ({ countCalculator, styles }) => {
    return (
      countCalculator > 0 && (
        <div onClick={onScroll} styleName={styles}>
          + {countCalculator} More
        </div>
      )
    );
  };
  RenderBadge.propTypes = {
    countCalculator: PropTypes.number.isRequired,
    styles: PropTypes.string.isRequired,
  };

  if (badgeData.length) {
    const isMobile = useDeviceType() !== "desktop";
    const countCalculator = badgeData.length - (isMobile ? 1 : 2);
    return (
      <>
        <div styleName="badges-container">
          {badgeData
            .map((rank, index) => {
              return (
                <div
                  onClick={(e) => {
                    // Call badge click handler if provided
                    if (onBadgeClick) {
                      onBadgeClick(rank.type + rank.year);
                    }
                    onScroll();
                    e.stopPropagation();
                  }}
                  styleName={`badge ${rank.type === "Most Powerful Women " ? "fortune500" : "next500"}`}
                  key={index}
                >
                  <Badge />
                  <span>
                    {rank.type}
                    {rank.year}
                  </span>
                </div>
              );
            })
            .slice(0, isMobile ? 1 : 2)}
          <RenderBadge countCalculator={countCalculator} styles="count-desktop" />
        </div>
        <RenderBadge countCalculator={countCalculator} styles="count-mobile" />
      </>
    );
  }
};
